/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { annoncement } from '../models/annoncement';
import type { user_all } from '../models/user_all';
import type { user_bug_report_dto } from '../models/user_bug_report_dto';
import type { user_bug_report_full } from '../models/user_bug_report_full';
import type { user_dto } from '../models/user_dto';
import type { user_preference } from '../models/user_preference';
import type { user_register } from '../models/user_register';
import type { user_register_dto } from '../models/user_register_dto';
import type { user_sign_in_access } from '../models/user_sign_in_access';
import type { user_sign_in_dto } from '../models/user_sign_in_dto';
import type { user_sign_out } from '../models/user_sign_out';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Open a new session
   * @returns user_sign_in_access successful
   * @throws ApiError
   */
  public userSignin({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: user_sign_in_dto;
  }): CancelablePromise<user_sign_in_access> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth/sign_in',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Logout the user
   * @returns user_sign_out successful
   * @throws ApiError
   */
  public userSignOut({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<user_sign_out> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/auth/sign_out',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Register a new user
   * @returns user_register successful
   * @throws ApiError
   */
  public userRegistration({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: user_register_dto;
  }): CancelablePromise<user_register> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/auth',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get annoncements
   * @returns annoncement successful
   * @throws ApiError
   */
  public getAnnoncements({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<annoncement>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/user/annoncements',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get last annoncement
   * @returns annoncement successful
   * @throws ApiError
   */
  public getLastAnnoncement({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<annoncement> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/user/annoncements/last',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get current User preferences
   * @returns user_preference successful
   * @throws ApiError
   */
  public getCurrentUserPreferences({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<user_preference> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/user/preferences',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create the bug report
   * @returns user_bug_report_full successful
   * @throws ApiError
   */
  public createUserBugReport({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: user_bug_report_dto;
  }): CancelablePromise<user_bug_report_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/user/user_bug_reports',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Search users (only registered account)
   * @returns user_all filtered result
   * @throws ApiError
   */
  public searchUsers({
    locale,
    q,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * filter on user name or email (min 3 letters)
     */
    q?: string;
  }): CancelablePromise<Array<user_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/user/users',
      path: {
        locale: locale,
      },
      query: {
        q: q,
      },
      errors: {
        401: `Guest account can not be used`,
      },
    });
  }
  /**
   * Update User
   * @returns user_all successful
   * @throws ApiError
   */
  public updateUser({
    locale,
    uuid,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * User identifier
     */
    uuid: string;
    requestBody?: user_dto;
  }): CancelablePromise<user_all> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/user/users/{uuid}',
      path: {
        locale: locale,
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
